{
  "titles": {
    "REVOLVING_BALANCE": "الأرصدة المدورة",
    "PURCHASE": "المشتريات",
    "SALE": "المبيعات",
    "DEBT_MOVEMENT": "مبيعات الذمم",
    "PAYMENT": "المدفوعات",
    "RECEIPT": "المقبوضات"
  },
  "products": {
    "DIESEL": "محروقات",
    "PETROL": "بنزين"
  },
  "columns": {
    "number": "الرقم",
    "date": "التاريخ",
    "postingDate": "تاريخ الترحيل",
    "dateTime": "التاريخ والوقت",
    "branch": "الفرع",
    "employee": "الموظف",
    "employeePhone": "رقم هاتف الموظف",
    "cashBalance": "الرصيد النقدي",
    "notes": "ملاحظات",
    "barrelPurchasePrice": "سعر شراء البرميل",
    "jerrycanPurchasePrice": "سعر شراء الجركل",
    "barrelSalePrice": "سعر بيع البرميل",
    "jerrycanSalePrice": "سعر بيع الجركل",
    "amount": "المبلغ",
    "lessJerrycans": "إلا جركل",
    "finalTotal": "الإجمالي النهائي",
    "deliveryStatus": "حالة التسليم",
    "movementType": "نوع الحركة",
    "debtor": "المدين",
    "vehicle": "المركبة",
    "personName": "اسم الشخص",
    "statement": "البيان",
    "messageStatus": "حالة الرسالة",
    "deliveryStatusValue": {
      "PENDING": "بانتظار التسليم",
      "DELIVERED": "تم التسليم"
    },
    "source": "المصدر",
    "priceStatus": "حالة التسعير",
    "customer": "العميل",
    "deliveredBy": "موظف التسليم",
    "pricedBy": "موظف التسعير",
    "postingStatus": "حالة الترحيل",
    "postingStatusValue": {
      "POSTED": "مرحلة",
      "PENDING": "غير مرحلة"
    },
    "shiftStatus": "حالة الشفت",
    "closedAt": "تاريخ ووقت الإغلاق"
  },
  "totals": {
    "sum": "المجموع",
    "totalBarrels": "إجمالي البراميل",
    "totalJerrycans": "إجمالي الجراكل",
    "totalDebit": "مجموع المدين",
    "totalCredit": "مجموع الدائن",
    "balance": "الرصيد"
  },
  "actions": {
    "export": "تصدير إلى Excel",
    "exportPdf": "تصدير PDF",
    "exportSelectedLimit": "يمكن تصدير {{max}} صف محدد كحد أقصى، ألغ تحديد بعض الصفوف",
    "view": "عرض",
    "delete": "حذف",
    "confirmDelivery": "تأكيد التسليم",
    "resendMessage": "إعادة إرسال الرسالة",
    "addManualMovement": "إضافة حركة يدوية",
    "editMovement": "تعديل حركة ذمم",
    "edit": "تعديل",
    "reprint": "إعادة طباعة",
    "completePrice": "إكمال السعر"
  },
  "kind": {
    "CHARGE": "مدين",
    "REPAYMENT": "دائن"
  },
  "toolbar": {
    "searchPlaceholder": "بحث بالرقم...",
    "searchLabel": "الرقم",
    "deliveryStatus": "حالة التسليم",
    "employee": "الموظف",
    "debtor": "المدين",
    "vehicle": "المركبة",
    "movementType": "نوع الحركة",
    "allStatuses": "جميع الحالات",
    "allEmployees": "جميع الموظفين",
    "allDebtors": "جميع عملاء الذمم",
    "allVehicles": "جميع المركبات",
    "allTypes": "جميع الأنواع",
    "fixedDayNote": "معروضة حسب تاريخ العمل الحالي لفرعك",
    "priceStatus": "حالة التسعير",
    "allPriceStatuses": "الكل",
    "postingStatus": "حالة الترحيل",
    "allPostingStatuses": "الكل"
  },
  "deleteConfirm": {
    "title": "حذف الحركة {{reference}}؟",
    "description": "سيتم حذف الحركة {{reference}} نهائيا من القائمة، ويمكن استعادتها من سلة المحذوفات. لا يمكن التراجع عن هذا الإجراء من هذه الشاشة."
  },
  "deleteManyConfirm": {
    "title": "حذف {{count}} حركة؟",
    "description": "سيتم حذف {{count}} حركة، ويمكن استعادتها من سلة المحذوفات."
  },
  "deliverConfirm": {
    "title": "تأكيد تسليم {{reference}}؟",
    "description": "سيتم تعليم الحركة {{reference}} كمسلمة، ولا يمكن التراجع عن هذا الإجراء."
  },
  "resendConfirm": {
    "title": "إعادة إرسال الرسالة؟",
    "description": "سيتم إعادة إرسال رسالة هذه الحركة إلى المدين."
  },
  "details": {
    "title": "تفاصيل الحركة {{reference}}",
    "description": "عرض كامل تفاصيل الحركة والأصناف والموظفين المشاركين والرسائل",
    "participants": "الموظفون المشاركون",
    "participantRole": {
      "ENTERED_BY": "أدخلها",
      "CASH_HANDLED_BY": "استلم النقد",
      "DELIVERED_BY": "سلمها",
      "EDITED_BY": "عدلها",
      "DELETED_BY": "حذفها",
      "RESTORED_BY": "استعادها",
      "PRICED_BY": "سعرها",
      "POSTED_BY": "رحلها"
    },
    "messages": "الرسائل",
    "lines": "الأصناف",
    "category": "الفئة",
    "qty": "الكمية",
    "fraction": "الفئة رقما",
    "reference": "الرقم",
    "product": "المنتج",
    "createdAt": "تم الإنشاء في",
    "deletedBy": "حذف بواسطة",
    "deletedAt": "تاريخ الحذف",
    "deliveredAt": "وقت التسليم",
    "id": "المعرف",
    "employeePhone": "رقم هاتف الموظف",
    "otherJerrycans": "فئات أخرى من الجراكل",
    "barrelsTotal": "مجموع البراميل",
    "jerrycansTotal": "مجموع الجراكل",
    "customersIntegration": "ربط نظام العملاء",
    "customersDeliveryFailed": "تعذر الإرسال إلى نظام العملاء"
  },
  "manualMovement": {
    "addTitle": "إضافة حركة يدوية",
    "editTitle": "تعديل حركة ذمم",
    "fields": {
      "branch": "الفرع",
      "movementType": "نوع الحركة",
      "debtor": "المدين",
      "vehicle": "المركبة",
      "amount": "المبلغ",
      "barrelPrice": "سعر بيع البرميل",
      "jerrycanPrice": "سعر بيع الجركل",
      "lessJerrycans": "إلا جركل",
      "notes": "ملاحظات",
      "isPriorBalance": "رصيد حركات سابق؟"
    },
    "priorBalanceSuffix": "(رصيد حركات سابق)",
    "summary": {
      "title": "ملخص الحركة",
      "totalBarrels": "إجمالي البراميل",
      "totalJerrycans": "إجمالي الجراكل",
      "amount": "المبلغ",
      "finalTotal": "الإجمالي النهائي",
      "invalidPhone": "رقم غير صالح: لن تصل الحركة إلى العملاء ولا إلى واتساب.",
      "currentBalance": "الرصيد الحالي",
      "debtLimit": "سقف الدين",
      "fitsLimit": "ضمن سقف الدين",
      "exceedsLimit": "يتجاوز سقف الدين"
    },
    "quantityGrid": {
      "title": "الكميات (اختياري، لأغراض التوثيق فقط)",
      "barrels": "براميل",
      "jerrycans": "جراكل"
    },
    "confirm": {
      "description": "يرجى مراجعة تفاصيل الحركة قبل الحفظ.",
      "commit": "حفظ الحركة",
      "branch": "الفرع",
      "product": "المنتج",
      "movementType": "نوع الحركة",
      "debtor": "المدين",
      "oldDebtor": "المدين السابق",
      "newDebtor": "المدين الجديد",
      "vehicle": "المركبة",
      "noVehicle": "بدون مركبة",
      "amount": "الإجمالي النهائي",
      "oldAmount": "المبلغ السابق",
      "newAmount": "المبلغ الجديد"
    },
    "validation": {
      "amountPositive": "المبلغ يجب أن يكون أكبر من صفر وبحد أقصى خمس منازل عشرية",
      "pricePositive": "السعر يجب أن يكون أكبر من صفر وبحد أقصى خمس منازل عشرية",
      "lessJerrycansNonNegative": "القيمة يجب أن تكون صفرا أو أكبر وبحد أقصى خمس منازل عشرية",
      "tooManyDecimals": "يسمح بخمس منازل عشرية كحد أقصى.",
      "vehicleNotOfDebtor": "هذه المركبة لا تتبع المدين المحدد"
    },
    "pricesNotPrefilled": "أدخل السعر يدويا؛ لا تملك صلاحية عرض الأسعار المحفوظة",
    "savedPending": "حفظت الحركة معلقة حتى ترحيلها"
  },
  "source": {
    "OPERATOR": "العمليات",
    "PDA": "PDA"
  },
  "priceStatus": {
    "PENDING": "بانتظار التسعير",
    "PRICED": "مسعرة"
  },
  "pda": {
    "title": "الـ PDA",
    "customer": "عميل المشتريات",
    "customerPhone": "رقم الهاتف",
    "vehiclePlate": "رقم المركبة",
    "vehicleType": "نوع المركبة",
    "vehicleNationality": "جنسية المركبة",
    "driverNationality": "جنسية السائق",
    "barrels": "عدد البراميل",
    "jerrycans": "عدد الجراكل",
    "deducted": "عدد الجراكل المخصومة",
    "netQuantity": "صافي الكمية"
  },
  "completePrice": {
    "title": "إكمال السعر",
    "description": "أدخل سعر الشراء للعملية {{reference}}. تحسب المبالغ من الكميات المسجلة.",
    "toast": "تم إكمال السعر",
    "summary": {
      "title": "ملخص العملية",
      "totalBarrels": "إجمالي البراميل",
      "totalJerrycans": "إجمالي الجراكل",
      "barrelsAmount": "مبلغ البراميل",
      "jerrycansAmount": "مبلغ الجراكل",
      "amount": "المبلغ",
      "finalTotal": "الإجمالي النهائي",
      "placeholder": "—"
    },
    "confirm": {
      "title": "تأكيد الحفظ",
      "description": "سيتم تسعير هذه العملية بشكل نهائي ولا يمكن تسعيرها مرة أخرى.",
      "commit": "حفظ السعر",
      "reference": "الرقم",
      "product": "المنتج"
    }
  },
  "posting": {
    "status": "حالة الترحيل",
    "time": "وقت الترحيل",
    "postedBy": "رحلها",
    "PENDING": "معلقة",
    "POSTED": "مرحلة",
    "forced": "ترحيل إجباري"
  },
  "shiftStatus": {
    "ACTIVE": "نشط",
    "CLOSED": "مغلق"
  }
}
